import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["id"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import u, { createContext as m, useContext as D, useMemo as l, useState as T } from "react";
import { useEvent as P } from '../../hooks/use-event.js';
import { useId as g } from '../../hooks/use-id.js';
import { useIsoMorphicEffect as E } from '../../hooks/use-iso-morphic-effect.js';
import { useSyncRefs as x } from '../../hooks/use-sync-refs.js';
import { forwardRefWithAs as y, render as R } from '../../utils/render.js';
var d = m(null);
function f() {
  var r = D(d);
  if (r === null) {
    var t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, f), t;
  }
  return r;
}
function w() {
  var _T = T([]),
    _T2 = _slicedToArray(_T, 2),
    r = _T2[0],
    t = _T2[1];
  return [r.length > 0 ? r.join(" ") : void 0, l(function () {
    return function (e) {
      var i = P(function (s) {
          return t(function (o) {
            return [].concat(_toConsumableArray(o), [s]);
          }), function () {
            return t(function (o) {
              var p = o.slice(),
                c = p.indexOf(s);
              return c !== -1 && p.splice(c, 1), p;
            });
          };
        }),
        n = l(function () {
          return {
            register: i,
            slot: e.slot,
            name: e.name,
            props: e.props
          };
        }, [i, e.slot, e.name, e.props]);
      return u.createElement(d.Provider, {
        value: n
      }, e.children);
    };
  }, [t])];
}
var I = "p";
function S(r, t) {
  var a = g(),
    _r$id = r.id,
    e = _r$id === void 0 ? "headlessui-description-".concat(a) : _r$id,
    i = _objectWithoutProperties(r, _excluded),
    n = f(),
    s = x(t);
  E(function () {
    return n.register(e);
  }, [e, n.register]);
  var o = _objectSpread(_objectSpread({
    ref: s
  }, n.props), {}, {
    id: e
  });
  return R({
    ourProps: o,
    theirProps: i,
    slot: n.slot || {},
    defaultTag: I,
    name: n.name || "Description"
  });
}
var h = y(S),
  G = Object.assign(h, {});
export { G as Description, w as useDescriptions };